$(document).ready(function () {

  const isCartNotEmpty = () => {
    return new Promise((resolve) => {
      return CartJS.getCart().then(cart => {
        return resolve(Boolean(cart.items.length));
      })
    });
  };

  const openCart = (fresh) => {
    if (typeof window.gocart === 'undefined') {
      return false;
    }  
    if (fresh) {
      window.gocart.openCartDrawer();
      window.gocart.fetchAndOpenCart();
    } else {
      window.gocart.openCartDrawer();
    }
    return true;
  };

  const getShippingBar = () => {
    return new Promise(resolve => {
      return fetch('/?sections=go-cart', {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => response.json())
      .then(data => resolve(data['go-cart']));
    });
  };

  const updateShippingBarSection = () => {
    return getShippingBar().then(section => {
      let drawer = $.parseHTML(section);
      let shippingBar = $(drawer).find('.shipping-bar').prop('outerHTML');
      $('.shipping-bar').replaceWith(shippingBar);
    });
  };

  $(document).on('cart.requestComplete', function (event, cart) {
    if ($(event.target.activeElement).hasClass('product-info__atc')) {
      isCartNotEmpty().then(result => openCart(result)).then(() => updateShippingBarSection());
      $(event.target.activeElement).blur();
    }
  });

  $('.js-go-cart-trigger').off('click').on('click', function () {
    isCartNotEmpty().then(result => openCart(result));
  });

  $(document).on('click', '.js-go-cart-drawer-close, .js-go-cart-quantity-plus, .js-go-cart-quantity-minus, .js-go-cart-quantity, .js-go-cart-remove-from-cart', function () {
    CartJS.getCart().then(() => {
      updateShippingBarSection();
    })
  });

});